/*
 *******************************************************************************
 *
 *  Filename:   /redux/slices/users.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Users redux reducer
 *
 *  Author:     Norman J. Nolasco [ Archetact Software ]
 *
 *  Created:    Friday, August 18, 2023 - 6:07 AM (CST)
 *
 *  Notes:
 *
 *  Revisions:
 *              2023/08/18  NJN Initial Build
 *
 *  Copyright (c) 2023 - Archetact Software - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userid: 0,
  companyid: 0,
  roleid: 0,
  userstatusid: 0,
  error: null,
  defaultToolPanel: "",
  columnState: [],
};

const intFields = ["userid", "companyid", "roleid", "userstatusid"];

const updateFieldReducer = (state, action, field) => {
  const value = action.payload ? action.payload[field] : undefined;

  if (value !== undefined) {
    state[field] = intFields.includes(field) ? parseInt(value, 10) : value;
    state.error = Number.isNaN(state[field]) ? `Invalid value for ${field}.` : null;
  } else {
    state.error = `No ${field} provided.`;
  }
};

export const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    updateUserID: (state, action) => updateFieldReducer(state, action, "userid"),
    updateCompany: (state, action) => updateFieldReducer(state, action, "companyid"),
    updateRole: (state, action) => updateFieldReducer(state, action, "roleid"),
    updateUserStatus: (state, action) => updateFieldReducer(state, action, "userstatusid"),
    updateDefaultToolPanel: (state, action) => updateFieldReducer(state, action, "defaultToolPanel"),
    updateColumnState: (state, action) => updateFieldReducer(state, action, "columnState"),
  },
});

export const {
  updateUserID,
  updateCompany,
  updateLocation,
  updateRole,
  updateUserStatus,
  updateDefaultToolPanel,
  updateColumnState,
} = usersSlice.actions;

export default usersSlice.reducer;
